const months = ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"];

export default date => {
  const month = months[date.getMonth()];
  const fullyear = date.getFullYear();
  return `${month} ${fullyear}`;
}